// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"48859efd","455":"a22bc398","977":"20770688"}[chunkId] + ".chunk.js";
};